import React from "react";

export const ButtonPrimary = ({
	name = "Primary",
	action = () => {
		console.log("go");
	},
}) => {
	return (
		<div className="flex gap-1 items-center justify-center bg-secondary py-2 pl-2 pr-3 rounded-lg cursor-pointer" onClick={action}>
			<div>
				<span className="mediumFont text-white text-[14px]">{name}</span>
			</div>
		</div>
	);
};
